import { render, staticRenderFns } from "./IngressRule.vue?vue&type=template&id=2ade5149&"
import script from "./IngressRule.vue?vue&type=script&lang=js&"
export * from "./IngressRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports